import debugFactory from 'debug';

const debug = debugFactory('cookieUtils');

const csrfToken = () => {
  const cookie = document.cookie;
  if (cookie.indexOf('CSRF-TOKEN') < 0) {
    return null;
  }

  /*
   * The regular expression was found here:
   * https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
   */
  const csrfTokenCookieValue = cookie.replace(/(?:(?:^|.*;\s*)CSRF-TOKEN\s*=\s*([^;]*).*$)|^.*$/, '$1');
  debug(`Cookie value for CSRF-TOKEN : ${csrfTokenCookieValue}`);

  return csrfTokenCookieValue;
};
export default csrfToken;



// WEBPACK FOOTER //
// ./book/src/commons/rest/cookieUtils.js